module.exports = __webpack_public_path__ + "static/media/crowleys.e9ce7102.png";